import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const WorkstationIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Monitor screen */}
      <path
        d="M2.5 4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5H15.8333C16.7538 2.5 17.5 3.24619 17.5 4.16667V11.6667C17.5 12.5871 16.7538 13.3333 15.8333 13.3333H4.16667C3.24619 13.3333 2.5 12.5871 2.5 11.6667V4.16667Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />

      {/* Monitor stand */}
      <path
        d="M10 13.3333V15.8333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />

      {/* Monitor base */}
      <path
        d="M6.66667 15.8333H13.3333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />

      {/* Keyboard indicator dots */}
      <path
        d="M7.5 17.0833C7.5 17.3135 7.31024 17.5 7.08333 17.5C6.85643 17.5 6.66667 17.3135 6.66667 17.0833C6.66667 16.8531 6.85643 16.6667 7.08333 16.6667C7.31024 16.6667 7.5 16.8531 7.5 17.0833ZM10.4167 17.0833C10.4167 17.3135 10.2269 17.5 10 17.5C9.7731 17.5 9.58333 17.3135 9.58333 17.0833C9.58333 16.8531 9.7731 16.6667 10 16.6667C10.2269 16.6667 10.4167 16.8531 10.4167 17.0833ZM13.3333 17.0833C13.3333 17.3135 13.1436 17.5 12.9167 17.5C12.6898 17.5 12.5 17.3135 12.5 17.0833C12.5 16.8531 12.6898 16.6667 12.9167 16.6667C13.1436 16.6667 13.3333 16.8531 13.3333 17.0833Z"
        fill="currentColor"
      />

      {/* Screen content indicator */}
      <path
        d="M5 5.83333H15M5 8.33333H12.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </BaseIcon>
  );
};

WorkstationIcon.displayName = 'WorkstationIcon';
